import * as React from 'react'
// import {Main} from '../../../Logic/Main'
// import {Logic} from '../../../Logic/Type'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {IconDefinition, SizeProp} from '@fortawesome/fontawesome-svg-core'

// console.log (fontawesome.toString().substring(0,0))
// import * as Assets from '../../../Assets/Assets'
/*
export function getLeaderboard
(ViewLarge: boolean, Verified: boolean, Data: Object[], rewards: number[], myPosition: number): JSX.Element {
    let positionsInLeaderboard: number = 10
    let header: JSX.Element =
        <tr>
            <th style = {{textAlign: 'center'}}>#</th>
            <th style = {{textAlign: 'center', width: '12px', padding: '0px', margin:'0px'}}/>
            <th style = {{textAlign: 'left'}}>{Assets.Name}</th>
            <th style = {{textAlign: 'right'}}>{Assets.Wagered}</th>
            {ViewLarge ? void 0 : <th style = {{textAlign: 'center'}}>{Assets.Reward}</th>}
        </tr>

    let body: JSX.Element[] = []

    if (Data)
    for (let i: number = 0; i < Data.length && i < positionsInLeaderboard; i++) {
        body.push(
            <tr
                key = {i.toString()}
                style = {i === myPosition ? {
                            color:  Main.Instance.IndexState.myPositionBetter ? '#0f0' :
                                    Main.Instance.IndexState.myPositionWorse ? '#fd2219' :
                                    Main.Instance.IndexState.myPointsChanged ? '#fdb919' : '#f38b00', 
                            fontWeight: 600} :
                         i < rewards.length ? {color: '#fdb919', fontWeight: 300} : {fontWeight: 300}}
            >
                <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>{(i + 1).toString()}</td>
                <td style = {{textAlign: 'center', color:'inherit', width:'12px', padding:'8px 0px 0px', margin:'0px'}}>
                    {i === myPosition ? 
                    Main.Instance.IndexState.myPositionBetter ?
                    <i style = {{margin:'1px 0px 0px -3px',display:'block',width:'12px'}} className = {Assets.arrowUp}/>
                    : Main.Instance.IndexState.myPositionWorse ?
                    <i style = {{margin:'1px 0px 0px -3px',display:'block',width:'12px'}} className={Assets.arrowDown}/>
                    : <i style = {{margin:'1px 0px 0px -3px',display:'block',width:'12px'}} className ={Assets.circle}/>
                    : void 0}
                </td>
                <td style = {{textAlign: 'left', fontWeight: 'inherit', color: 'inherit'}}>{Data[i]['player']}</td>
                <td style = {{textAlign: 'right', fontWeight: 'inherit', color: 'inherit'}}>
                    {Data[i]['wagers'] + '€'}
                </td>
                {ViewLarge ? void 0 :
                <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>
                    {i < rewards.length ? rewards[i] + '€' : '—'}
                </td>}
            </tr>
        )
    }

    let footer: JSX.Element = (myPosition === -1 || !Data) ? undefined :
        <tr 
            style = {Main.Instance.IndexState.myPositionBetter ? {color:'#0f0', fontWeight: 600} :
                    Main.Instance.IndexState.myPositionWorse ? {color:'#fd2219', fontWeight: 600} :
                    Main.Instance.IndexState.myPointsChanged ? {color: '#fdb919', fontWeight: 600} :
                    {color: '#f38b00', fontWeight: 600}}
        >
            <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>
                {(myPosition + 1).toString()}
            </td>
            <td style = {{textAlign: 'center', color:'inherit', width:'12px', padding:'8px 0px 0px', margin:'0px'}}>
                {Main.Instance.IndexState.myPositionBetter ?
                <i style = {{margin:'1px 0px 0px -3px', display: 'block', width:'12px'}} className = {Assets.arrowUp}/>
                : Main.Instance.IndexState.myPositionWorse ?
                <i style = {{margin:'1px 0px 0px -3px', display:'block', width:'12px'}} className = {Assets.arrowDown}/>
                : <i style = {{margin:'1px 0px 0px -3px', display:'block', width:'12px'}} className = {Assets.circle}/>}
            </td>
            <td style = {{textAlign: 'left', fontWeight: 'inherit', color: 'inherit'}}>{Data[myPosition]['player']}</td>
            <td style = {{textAlign: 'right', fontWeight: 'inherit', color: 'inherit'}}>
                {Data[myPosition]['wagers']}
            </td>
            {ViewLarge ? void 0 :
            <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>
                {myPosition < rewards.length ? rewards[myPosition] + '€' : '—'}
            </td>}
        </tr>

    return (header && body && Verified ?
        <table style = {{color: '#fff'}} className = "table table-responsive mbzero">
            <thead>
                {header}
            </thead>
            {footer ?
            <tfoot>
                {footer}
            </tfoot>
            : void 0}
            <tbody>
                {body}
            </tbody>
        </table> : void 0)
}

export function getLeaderboardPrizes
(ViewLarge: boolean, Verified: boolean, Data: Object[], rewards: number[], myPosition: number): JSX.Element {
    let Header: JSX.Element = 
    <tr>
        <th style = {{textAlign: 'center'}}>#</th>
        <th style = {{textAlign: 'left'}}>{Assets.Name}</th>
        <th style = {{textAlign: 'center'}}>{Assets.Reward}</th>
    </tr>

    let Body: JSX.Element[] = []
    if (Data)
    for (let i: number = 0; i < rewards.length; i++) {
        Body.push(
            <tr
                key = {i.toString()}
                style = {i === myPosition ? {color: '#f38b00', fontWeight: 600} : 
                        i < rewards.length ? {color: '#fdb919', fontWeight: 300} : {fontWeight: 300}}
            >
                <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>{(i + 1).toString()}</td>
                <td style = {{textAlign: 'left', fontWeight: 'inherit', color: 'inherit'}}>{Data[i]['player']}</td>
                <td style = {{textAlign: 'center', fontWeight: 'inherit', color: 'inherit'}}>
                    {i < rewards.length ? rewards[i] + '€' : '—'}
                </td>
            </tr>
        )
    }

    return (Header && Body && ViewLarge && Verified ?
        <table style = {{color: '#fff'}} className = "table table-responsive mbzero">
            <thead>
                {Header}
            </thead>

            <tbody>
                {Body}
            </tbody>
        </table>
    : void 0)
}
*/
/*
export class LoginInput extends React.Component<{onChange: (text: string) => void, type:string, placeholder:string, 
icon:string}, {Text: string}> {
    
    render(): JSX.Element {
    return (
            <div className = "input-group margin-bottom-sm">
                <span className = "input-group-addon">
                    <i className={this.props.icon}/>
                </span>
                <input 
                        className = "form-control" 
                        type = {this.props.type} 
                        placeholder = {this.props.placeholder} 
                        onChange = {event => this.onChange(event)}
                />
            </div>
        )
    }

    private onChange(event: React.FormEvent<HTMLInputElement>): void {
    this.state.Text = event.currentTarget.value
    this.props.onChange(event.currentTarget.value)
    }

    state = {
    Text: ''
    }
}

export class FormInputNumber extends React.Component<{onChange: (text: string) => void, description?:string,
    icon?:string, value:string, type:string, ClassName:string, min:string, max?:string, style?:Object, 
    outerDiv?:string}, {Text: string}> {
    
    render(): JSX.Element {

        if (this.props.icon) {
            return (
                <div className = {this.props.outerDiv ? this.props.outerDiv : ''}>
                <span
                    className = {this.props.ClassName.indexOf('h26') !== -1 ? 
                    'input-group-addon h26' : 'input-group-addon'}
                >
                    <i className = {this.props.icon}/>
                </span>
                <input
                        title = {this.props.description}
                        value = {this.props.value}
                        className = {this.props.ClassName}
                        type = {this.props.type}
                        min = {this.props.min}
                        max = {this.props.max ? this.props.max : ''}
                        onChange = {event => this.onChange(event)}
                />
                </div>
            )
            }

        return (
            <input 
                style = {this.props.style}
                title = {this.props.description}
                value = {this.props.value}
                className = {this.props.ClassName}
                type = {this.props.type}
                min = {this.props.min}
                max = {this.props.max ? this.props.max : ''}
                onChange = {event => this.onChange(event)}
            />
        )
    }

    private onChange(event: React.FormEvent<HTMLInputElement>): void {
        this.state.Text = ''
        this.props.onChange(event.currentTarget.value)
    }

    state = {
    Text: ''
    }
}

export class Input extends React.Component
    <{onChange: (text: string) => void, type:string, desc:string, min?:string,max?:string,
      val:string, placeholder?:string, className?:string, readOnly?:boolean, tabIndex?:number}, 
     {Text: string}> {

    state = {
      Text: ''
    }

    render(): JSX.Element {

    if (this.props.readOnly) {

      return (
            <input  
                tabIndex = {this.props.tabIndex ? this.props.tabIndex : 0}
                className = {this.props.className ? this.props.className : ''}
                placeholder = {this.props.placeholder} 
                title = {this.props.desc}
                value = {this.props.val}
                type = {this.props.type}
                readOnly = {true}
            />
        )

    }  else if (this.props.min) {

      return (
            <input  
                tabIndex = {this.props.tabIndex ? this.props.tabIndex : 0}
                className = {this.props.className ? this.props.className : ''}
                placeholder = {this.props.placeholder} 
                title = {this.props.desc}
                min = {this.props.min}
                value = {this.props.val}
                type = {this.props.type}
                onChange = {event => this.onChange(event)}
            />
        )

    } else {
        return (
                <input  
                    tabIndex = {this.props.tabIndex ? this.props.tabIndex : 0}
                    className = {this.props.className ? this.props.className : ''}
                    placeholder = {this.props.placeholder} 
                    title = {this.props.desc}
                    value = {this.props.val}
                    type = {this.props.type}
                    onChange = {event => this.onChange(event)}
                />
            )
        }
    }
    private onChange(event: React.FormEvent<HTMLInputElement>): void {

      this.state.Text = event.currentTarget.value
      this.props.onChange(event.currentTarget.value)
    }
}
*/
/*
export class Clock extends React.Component<{interval:number,max:number}, {}> {

    ms: number = 1000

    timerID
    constructor(props) {
        super(props)
    }

    componentDidMount() {this.timerID = setInterval(() => this.tick(), this.ms * this.props.interval);}

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {

        if (Main.Instance.LoginState.SelectionBanner === this.props.max) {

            Logic.Type.New(Main.Instance.LoginState, {SelectionBanner: 1})
        } else {

            Logic.Type.New(Main.Instance.LoginState, {SelectionBanner: Main.Instance.LoginState.SelectionBanner + 1})
        }      
    }

    render() { 

        return null  
    }
}
*/
/*
            {this.props.text}&nbsp;
              <img className = "activity-image"
              src = {this.props.value == true ? this.props.i1 : this.props.i2}/>

*/
/*
export class Sort extends React.Component<{ onClick: (text: string) => void, value:boolean, ClassName:string,
    title?:string, i1:string, i2:string, i0?:string,sortActive: boolean, text?:string}, {Text: string}> {
    
    componentWillMount() {
        this.state.Text = this.props.value.toString()
    }

    render(): JSX.Element {

    return (
        <button
            style = {{float: 'left', display: 'block', marginTop : '3px'}}
            title = {!this.props.title ? '' : this.props.title}
            onClick = {event => this.onClick(event)}
            className = {this.props.ClassName}
        >
        {!this.props.i0 ? this.props.sortActive ?
            <i className = {this.props.value == true ? 'Sort-Icon ' + this.props.i1 : 'Sort-Icon ' + this.props.i2}/>
            :
            <i className = {this.props.value == true ? 'Sort-icon ' + this.props.i1 : 'Sort-icon ' + this.props.i2}/>
        : void 0}
        {this.props.i0 ? this.props.sortActive ?
            <span className = "Sort-Icon">
            <i className = {this.props.value == true ? 'sort-Icon ' + this.props.i1 : 'sort-Icon ' + this.props.i2}/>
            <i className = {'sort-Icon ' + this.props.i0}/>
            </span>
            :
            <span className = "Sort-icon">
            <i className = {this.props.value == true ? 'sort-icon ' + this.props.i1 : 'sort-icon ' + this.props.i2}/>
            <i className = {'sort-icon ' + this.props.i0}/> 
            </span>

        : void 0}
        </button>)

    }

    private onClick(event: React.FormEvent<HTMLElement>): void {

    if (this.state.Text == 'false') {
        this.state.Text = 'true'
        this.props.onClick('true')
    } else if (this.state.Text == 'true') {
        this.state.Text = 'false'
        this.props.onClick('false')
    }
    }

    state = {
    Text: ''
    }
}
*/

export class Select extends React.Component<{onChange: (text: string) => void, value: string, data: Object[], icon: IconDefinition, title: string,
classname: string, selectClassName: string, spanClassname: string, size?: SizeProp, description?: string}, {Text:string}> {
    
    render(): JSX.Element {

      let Rows:JSX.Element[] = []
      Rows.push(
        <option 
            key = "-1" 
            value = "0"
        >
            {this.props.title}
        </option>
      )
      if (this.props.data)
      this.props.data.forEach((item: {id: string, name: string}) => {  
        Rows.push(
          <option 
              key = {item.id.toString()} 
              value = {item.id}
          >
              {item.name}
          </option>
          )
      })
                
      return (
          <div className = {this.props.classname}>
            <span className = {'input-group-addon ' + this.props.spanClassname}>
              <FontAwesomeIcon icon = {this.props.icon} size = {this.props.size}/>
            </span>
            {this.props.description ?
            <select
              value = {this.props.value} 
              className = {'form-control ' + this.props.selectClassName}
              title = {this.props.description}
              onChange = {event => this.onChange(event)}
            >
                {Rows}
            </select>
            :
            <select
              value = {this.props.value} 
              className = {'form-control ' + this.props.selectClassName}
              onChange = {event => this.onChange(event)}
            >
                {Rows}
            </select>
            }
          </div>
      )
    }
  
    private onChange(event: React.FormEvent<HTMLSelectElement>): void {
      this.state.Text = event.currentTarget.value
      this.props.onChange(event.currentTarget.value)
    }
  
    state = {
      Text: ''
    }
  }


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Reusables.tsx